export default __webpack_public_path__ + "static/media/FolderOpen.521c1907.svg";